import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { UserProvider } from "./userprofile/UserContext";
import { CourseProvider } from "./course/CourseContext";
import { SidebarProvider } from "./sidebar/SidebarContext";
import { ChatBotContextProvider } from "./chatbot/ChatBotContext";
import { ProblemNavProvider } from "./navbar/ProblemNavContext";
import { NavBarActionsProvider } from "./navbar/NavBarActions";
import { AUTH_OR_DEV_LOGIN_ENABLED } from "./config";

const queryClient = new QueryClient();

export default function AppProviders({ children }) {
  const shouldMountChatProvider = AUTH_OR_DEV_LOGIN_ENABLED;

  const appTree = shouldMountChatProvider ? (
    <ChatBotContextProvider>{children}</ChatBotContextProvider>
  ) : (
    children
  );

  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <SidebarProvider>
          <CourseProvider>
            <ProblemNavProvider>
              <NavBarActionsProvider>{appTree}</NavBarActionsProvider>
            </ProblemNavProvider>
          </CourseProvider>
        </SidebarProvider>
      </UserProvider>
    </QueryClientProvider>
  );
}
